import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@redux-devtools/ui';
import { FaTerminal } from 'react-icons/fa';
import { toggleDispatcher } from '../../actions/index.js';
class DispatcherButton extends Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.dispatcherIsOpen !== this.props.dispatcherIsOpen;
    }
    render() {
        return (React.createElement(Button, { mark: this.props.dispatcherIsOpen && 'base0D', title: this.props.dispatcherIsOpen ? 'Hide dispatcher' : 'Show dispatcher', onClick: this.props.toggleDispatcher, tooltipPosition: "top-left" },
            React.createElement(FaTerminal, null)));
    }
}
const actionCreators = {
    toggleDispatcher,
};
export default connect(null, actionCreators)(DispatcherButton);
